<template>
  <div class="wrapper">
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="产品名称">
          <el-input v-model="searchData.productName" size="small" placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item label="供应商">
          <el-input v-model="searchData.companyName" size="small" placeholder="请输入供应商" />
        </el-form-item>
        <el-form-item label="对接商务">
          <SelectAdmin v-model="searchData.businessUserId"></SelectAdmin>
        </el-form-item>
        <el-form-item label="月份选择">
          <el-date-picker
              style="width:250px;"
              size="small"
              v-model="searchData.timeSlot"
              value-format="yyyy-MM"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="getList">搜索</el-button>
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-divider></el-divider>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getMonthListAPI } from "./api";
import SelectAdmin from "@/views/components/select-admin.vue";

const columns = [
  {
    label: "产品名称",
    prop: "productName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["productName"]}</p>;
    },
  },
  {
    label: "供应商名称",
    prop: "companyName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["companyName"]}</p>;
    },
  },
  {
    label: "统计月份",
    prop: "month",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["month"]}</p>;
    },
  },
  {
    label: "对接商务",
    prop: "businessUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["businessUserName"]}</p>;
    },
  },
  {
    label: "PV",
    prop: "pv",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["pv"]}</p>;
    },
  },
  {
    label: "UV",
    prop: "uv",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["uv"]}</p>;
    },
  },
];

export default {
  name: "ProductBiMonthList",
  components: {SelectAdmin},
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        productName: "",
        companyName: "",
        businessUserId: undefined,
        timeSlot: [],
        minMonth: '',
        maxMonth: ''
      },
    };
  },

  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      const { productName, companyName, timeSlot } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize, productName, companyName };
      if (timeSlot && timeSlot.length > 0) {
        params.minMonth = timeSlot[0] || '';
        params.maxMonth = timeSlot[1] || '';
      }
      const res = await getMonthListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .el-form {
    .el-form-item {
      margin-right: 35px;
    }
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .el-drawer {
    .el-drawer__header {
      font-size: 18px;
      font-weight: 600;
    }
    .goods-box {
      padding: 0 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
}
</style>
